import { Button } from "@sellar-io/components";
import { OrderPaymentType } from "@sellar-io/api-v2/types";
import { ReactElement } from "react";
import {
  Dialog,
  DialogNavigation,
  DialogCTA,
} from "../../../components/modal/Dialog";
import { useEvents } from "../../../hooks";
import { useOrderMarkAsPaid } from "../../../hooks/api/v2/order/useOrderMarkAsPaid";

export function OrderPaidModal({
  active,
  onDismiss,
  orderId,
  paymentType,
}: {
  active: boolean;
  onDismiss: () => void;
  orderId: number;
  paymentType: OrderPaymentType | null;
}): ReactElement {
  const { track } = useEvents();

  const mutation = useOrderMarkAsPaid(orderId);

  const onConfirm = async () => {
    const paidAt = new Date();

    mutation.mutate(
      {
        paidAt,
      },
      {
        onSuccess: () => {
          track("Order Marked As Paid", {
            initiator: "supplier",
            orderId: orderId,
            paidAt,
          });
          onDismiss();
        },
      },
    );
  };

  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <DialogNavigation
        title="Mark this order as paid"
        description={`Completing this action will mark the order as paid. This cannot be undone${
          paymentType === "stripe"
            ? " and will update the invoice on Stripe."
            : "."
        }`}
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={onDismiss}
      />
      <DialogCTA>
        <Button onClick={onConfirm} loading={mutation.isPending}>
          Order paid
        </Button>
      </DialogCTA>
    </Dialog>
  );
}
